import { ClearTransientAccessCredCommand } from '../../commands/clear_transient_access_cred_command';
import { TransientAccessCredEventNames } from '../../constants/transient_access_cred_constants';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { PreventTransientAccessQuery } from '../../queries/prevent_transient_access_query';
import * as _4 from 'lodash4';

export class TransientAccessCredStepsComponent {
  private readonly chooseActionSwitchValue = 'choose-action';
  private readonly confirmAuthSwitchValue = 'confirm-auth';
  private selectedStepValue = this.chooseActionSwitchValue;

  private uniqueId = _4.uniqueId();
  private commonIdentifier = 'transient-access-cred-';

  private stepGroupId = `${this.commonIdentifier}steps-${this.uniqueId}`;

  private toggleStepsBound = this.toggleSteps.bind(this);

  constructor(
    private ngPreventTransientAccessQuery: PreventTransientAccessQuery,
    private clearTransientAccessCredCommand: ClearTransientAccessCredCommand,
    private ngComponentCommunicatorService: CommunicatorService
  ) {}

  $onInit() {
    this.clearTransientAccessCredCommand();
    this.ngComponentCommunicatorService.subscribe(
      TransientAccessCredEventNames.TOGGLE_CRED_STEPS,
      this.toggleStepsBound
    );
  }

  $onDestroy() {
    this.ngComponentCommunicatorService.release(TransientAccessCredEventNames.TOGGLE_CRED_STEPS, this.toggleStepsBound);
  }

  toggleSteps() {
    const toggleStepMap = {
      [this.confirmAuthSwitchValue]: this.chooseActionSwitchValue,
      [this.chooseActionSwitchValue]: this.confirmAuthSwitchValue
    };
    this.selectedStepValue = toggleStepMap[this.selectedStepValue];
  }

  stepSelectionChanged($event: any) {
    if (_4.isNil($event.detail.value)) {
      return;
    }
    if (this.selectedStepValue !== $event.detail.value) {
      this.selectedStepValue = $event.detail.value;
    }
  }
}

angular.module('capability-ng-scheduler').component('transientAccessCredStepsComponent', {
  controller: TransientAccessCredStepsComponent,
  transclude: true,
  templateUrl:
    'capability-ng-scheduler/src/prevent_transient_access/components/transient_access_cred_steps_component/transient_access_cred_steps_component.html'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/prevent_transient_access/components/transient_access_cred_steps_component/transient_access_cred_steps_component.ts